import React, {
  createContext,
  useContext,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react";
import axiosInstance from "../Config/axios";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { useLogin } from "./LoginContext";
import { useNewUser } from "./NewUserContext";

const BuyPackagesContext = createContext();
export const useBuyPackages = () => useContext(BuyPackagesContext);

export const BuyPackagesProvider = ({ children }) => {
  const { fetchCartCount } = useNewUser();
  const { user, updateUser } = useLogin();
  const [listPackages, setListPackages] = useState([]);
  const [packageDetails, setPackageDetails] = useState(null);
  const [packageDetailsByIDs, setPackageDetailsByIDs] = useState(null);
  const [loading, setLoading] = useState(false);
  const toastRef = useRef(null);
  const clearPackages = () => setListPackages([]);
  const navigate = useNavigate();
  const fetchPackages = useCallback(async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;

    try {
      const response = await axiosInstance.get(
        "/customer/packages/",
        headers_data,
      );

      setListPackages(response.data);
    } catch (err) {
      setLoading(false);
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";

      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Error",
      //   detail: errorDetail,
      //   life: 3000,
      // });
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchPackagesDetailsByID = async (id) => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Unauthorized",
      //   detail: "Access token missing. Please log in again.",
      //   life: 4000,
      // });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }

    try {
      const response = await axiosInstance.get(`/adminpanel/packages/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setPackageDetails(response.data);
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch package details";
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Error",
      //   detail: errorDetail,
      //   life: 3000,
      // });
    }
  };

  const fetchPackagesDetailsByIDs = async (data) => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Unauthorized",
      //   detail: "Access token missing. Please log in again.",
      //   life: 4000,
      // });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }

    try {
      const response = await axiosInstance.post(
        `/adminpanel/packages/bulk/`,
        data,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        },
      );
      setPackageDetailsByIDs(response.data);
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch package details";
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Error",
      //   detail: errorDetail,
      //   life: 3000,
      // });
    }
  };

  const proceedToCheckout = async (data) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Unauthorized",
      //   detail: "Access token missing. Please log in again.",
      //   life: 4000,
      // });
      clearPackages();
      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }

    try {
      const response = await axiosInstance.post(`/payment/checkout/`, data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (err) {
      const errorDetail =
        err.response?.data?.message || "Failed to procced with checkout";
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Error",
      //   detail: errorDetail,
      //   life: 3000,
      // });
    }
  };

  const verifyPaymentCheck = async (id) => {
    const accessToken = localStorage.getItem("accessToken");

    // if (!accessToken) {
    //   toastRef.current?.show({
    //     severity: "error",
    //     summary: "Unauthorized",
    //     detail: "Access token missing. Please log in again.",
    //     life: 4000,
    //   });
    //   clearPackages();
    //   localStorage.clear();
    //   navigate("/login", { replace: true });
    //   return;
    // }

    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;

    try {
      const response = await axiosInstance.get(
        `/payment/verify_payment/?session_id=${id}`,
        headers_data,
      );
      let paymentStatus = "";
      if (accessToken) {
        paymentStatus = response.data[0].payment.paid;
      } else {
        paymentStatus = response.data.sales[0].payment.paid;
        updateUser(response.data);
      }

      if (paymentStatus === true) {
        navigate("/payment-success");
      } else {
        navigate("/payment-failed");
      }
      // Handle the response data as needed
    } catch (err) {
      const errorDetail =
        err.response?.data?.message || "Failed to verify payment";
      // toastRef.current?.show({
      //   severity: "error",
      //   summary: "Error",
      //   detail: errorDetail,
      //   life: 3000,
      // });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const storedUser = localStorage.getItem("user");

    if (!token || !storedUser) return;

    // fetchPackages();
  }, []);

  return (
    <BuyPackagesContext.Provider
      value={{
        listPackages,
        fetchPackages,
        packageDetails,
        fetchPackagesDetailsByID,
        proceedToCheckout,
        verifyPaymentCheck,
        packageDetailsByIDs,
        fetchPackagesDetailsByIDs,
        loading,
      }}
    >
      <Toast ref={toastRef} />
      {children}
    </BuyPackagesContext.Provider>
  );
};
